import { usePressEventTracker } from '@objectiv/tracker-react';
import { makePressableContext } from '@objectiv/schema';
import clsx from 'clsx';
import { useRef } from 'react';
import { navigate } from 'gatsby';
import { tildeToSoftHyphen } from '~utils/string';
import { convertBlogCategoryToSlug, extractBlogCategory } from '~build/utils';
import { BaseLink } from '~components/BaseLink';
import { Image } from '~components/Image';

import { card, image, category, title, intro } from './ContentfulComponentRelatedArticles.module.css';

import type { ImageType } from '~components/Image';

export type Article = {
  category: string;
  slug: string;
  title: string;
  intro: string;
  socialMediaImage: ImageType;
  featured?: boolean;
};

type ArticleCardProps = {
  article: Article;
  className?: string;
};

export const ArticleCard: React.FC<ArticleCardProps> = ({ article, className }): JSX.Element => {
  const path = `/blog${convertBlogCategoryToSlug(article.category)}/${article.slug.trim()}/`;
  const linkRef = useRef<HTMLAnchorElement>(null);
  const pressEventTrigger = usePressEventTracker({
    locationStack: [makePressableContext({ id: `article-card-${path}` })],
  });

  return (
    <div
      className={clsx(card, className)}
      onClick={async ({ target }) => {
        if (linkRef.current?.contains(target as HTMLElement)) return;
        await pressEventTrigger();
        navigate(path);
      }}
    >
      <Image className={image} image={article.socialMediaImage} width={760} />
      <span className={category}>{extractBlogCategory(article.category)}</span>
      <BaseLink className={title} href={path} ref={linkRef}>
        {tildeToSoftHyphen(article.title)}
      </BaseLink>
      <p className={intro}>{article.intro}</p>
    </div>
  );
};
